module.exports = __webpack_public_path__ + "img/undraw_pie_chart_6efe.51b33136.svg";